import fr from "./locales/fr.json";
import nl from "./locales/nl.json";
import be from "./locales/nl-BE.json";

/*
 * We are (unfortunately) using nl-NL as code for the dutch language in allefolders,
 * and just 'nl' as code for flemish in promopromo, because promopromo uses the /nl prefix.
 * This also reflects in the defineI18nroutes compiler macro found on the pages components.
 */
export default defineI18nConfig(() => ({
  fallbackLocale: "nl-NL",
  defaultLocale: "nl-NL",
  domainLocales: ["nl-NL", "nl", "fr"],
  globalInjection: true,
  legacy: false,

  locales: [
    {
      code: "nl-NL",
      file: "nl.json",
      name: "NL",
      language: "nl-NL",
    },
    {
      code: "nl",
      file: "nl-BE.json",
      name: "BE",
      language: "nl-BE",
    },
    {
      code: "fr",
      file: "fr.json",
      name: "FR",
      language: "fr-FR",
    },
  ],
  messages: {
    "nl-NL": nl,
    nl: be,
    fr: fr,
  },
}));
